import { render, staticRenderFns } from "./view-student.vue?vue&type=template&id=9af77e3e&scoped=true&"
import script from "./view-student.vue?vue&type=script&lang=js&"
export * from "./view-student.vue?vue&type=script&lang=js&"
import style0 from "./view-student.vue?vue&type=style&index=0&id=9af77e3e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af77e3e",
  null
  
)

export default component.exports